export const dashboard = {
  title: "Panel",
  filters: {
    accommodation: "Obiekt",
    allAccommodations: "Wszystkie obiekty",
    period: "Okres",
    periodOptions: {
      today: "Dziś",
      week: "Tydzień",
      month: "Miesiąc",
      year: "Rok",
    },
  },
  actions: {
    createBooking: "Utwórz rezerwację",
  },
  pendingWidget: {
    title: "Oczekujące działania",
    subtitle: "Płatności, zapytania i pokoje do przypisania.",
    oneRequest: "zapytanie",
    manyRequests: "zapytań",
    onePayment: "płatność",
    manyPayments: "płatności",
    oneUnassigned: "do przypisania",
    manyUnassigned: "do przypisania",
    loading: "Wczytywanie oczekujących działań...",
    emptyTitle: "Brak oczekujących działań",
    emptyText: "Gdy pojawi się nowe zapytanie lub rezerwacja oczekująca na płatność, wyświetli się w tym miejscu.",
    noName: "Bez nazwy",
    accommodation: "Obiekt",
    guest: "gość",
    guests: "goście",
    requestShort: "Zapytanie",
    pendingPaymentShort: "Oczekuje na płatność",
    unassignedShort: "Przypisz pokój",
    approve: "Zatwierdź",
    reject: "Odrzuć",
    viewAll: "Zobacz wszystkie rezerwacje",
    modalApproveTitle: "Zatwierdź zapytanie",
    modalRejectTitle: "Odrzuć zapytanie",
    modalApproveText1: "Zaraz zostanie zatwierdzone zapytanie od",
    modalApproveText2: "Jeśli ta rezerwacja korzysta z płatności online, przejdzie w stan oczekiwania na płatność.",
    modalRejectText1: "Zaraz zostanie odrzucone zapytanie od",
    modalRejectText2: "Można podać powód, który zostanie wysłany gościowi e-mailem.",
    rejectReasonLabel: "Powód odrzucenia",
    rejectReasonPlaceholder: "Proszę wybrać powód",
    reasonDatesUnavailable: "Terminy nie są już dostępne",
    reasonPriceUnavailable: "Stawka nie jest już dostępna",
    reasonMinimumStay: "Nie spełnia minimalnej długości pobytu",
    reasonHouseRules: "Nie spełnia zasad obiektu",
    reasonOther: "Inny powód",
    rejectReasonOtherPlaceholder: "Proszę wpisać powód odrzucenia",
    rejectReasonRequired: "Należy wybrać powód odrzucenia.",
    rejectReasonOtherRequired: "Należy wpisać powód odrzucenia.",
    cancel: "Anuluj",
    confirmApprove: "Tak, zatwierdź",
    confirmReject: "Tak, odrzuć",
    statusUpdatedSuccess: "Status został zaktualizowany.",
    statusUpdatedError: "Nie udało się zaktualizować statusu."
  },

  stats: {
    totalReservations: {
      today:   "Rezerwacje dzisiaj",
      week:    "Rezerwacje w tym tygodniu",
      month:   "Rezerwacje w tym miesiącu",
      year:    "Rezerwacje w tym roku",
      default: "Rezerwacje łącznie",
    },
    checkIns: {
      today:   "Check-iny dzisiaj",
      week:    "Check-iny w tym tygodniu",
      month:   "Check-iny w tym miesiącu",
      year:    "Check-iny w tym roku",
      default: "Check-iny",
    },
    occupancy: {
      today:   "Obłożenie dzisiaj",
      week:    "Obłożenie tygodniowe",
      month:   "Obłożenie miesięczne",
      year:    "Obłożenie roczne",
      default: "Obłożenie",
    },
    revenue: {
      today:   "Przychód dzisiaj",
      week:    "Przychód tygodniowy",
      month:   "Przychód miesięczny",
      year:    "Przychód roczny",
      default: "Przychód",
    },
  },
  section3: {
    title: "Nadchodzące rezerwacje",
    subtitle: "Lista nadchodzących przyjazdów do obiektu",
    timeFilters: {
      upcoming: "Nadchodzące",
      thisWeek: "Ten tydzień",
      today: "Dziś",
      tomorrow: "Jutro",
      month: "Miesiąc",
    },
    table: {
      headers: {
        responsible: "Osoba odpowiedzialna",
        checkInDate: "Data check-inu",
        entry: "Wejście",
        guests: "Goście",
        status: "Status",
      },
    },
    empty: {
      today: {
        title: "Brak przyjazdów na dziś",
        description:
          "Gdy pojawi się nowy przyjazd zaplanowany na dziś, wyświetli się tutaj wraz z najważniejszymi szczegółami.",
      },
      default: {
        title: "Brak nadchodzących przyjazdów",
        description:
          "Gdy pojawią się nowe zaplanowane przyjazdy, wyświetlą się tutaj wraz z najważniejszymi szczegółami.",
      },
    },
    loading: "Wczytywanie rezerwacji...",
    statuses: {
      inProgress: "W toku",
      complete: "Zakończony",
      pending: "Oczekujący",
      approved: "Zatwierdzony",
    },
    actions: {
      replyOnWhatsApp: "Odpowiedz na WhatsAppie",
    },
    nights: "{count} noc | {count} noce | {count} nocy",
  },
  section4: {
    title: "Struktura przychodów",
    total: "Przychód łącznie",
    emptyChart: "Brak dostępnych danych",
    noData: "Brak danych o przychodach do wyświetlenia",
  },
  section5: {
    title: "Przychód łącznie",
    datasetLabel: "Przychód",
    filters: {
      weekly: "Tygodniowo",
      monthly: "Miesięcznie",
      "6m": "6 miesięcy",
      "12m": "12 miesięcy",
      "24m": "24 miesiące",
    },
    loading: "Wczytywanie danych...",
    errors: {
      load: "Błąd wczytywania danych",
      connection: "Błąd połączenia",
    },
  },
  design: {
    title: `Wygląd panelu`,
    reorder: `Zmień kolejność`,
    active: `Aktywny`,
    theme: `Motyw`,
    color: `Kolor`,
    green: `Zielony`,
    system: `Systemowy`,
    white: `Biały`,
    sidebar: `Pasek boczny`,
    black: `Czarny`,
  },
  earlyCheckin: {
    earlyShort: `Wcześniej`,
    arrivesShort: `Przyjazd`,
    arrivalAt: `O {time}`,
    requested: `Prośba o wcześniejszy check-in`,
    arrivalRequested: `Prośba o podanie godziny przyjazdu`,
  },
};
